import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { makeStyles } from '@material-ui/core';
import { CloseIcon } from '../components/Icon';
import useScanQrcode from './useScanQrcode';

const useStyle = makeStyles(() => ({
  root: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    zIndex: '2000',
    transform: 'translateY(-4.375rem)',
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
    position: 'absolute',
  },
  closeIcon: {
    fontSize: '2rem',
    color: '#ffffff',
    position: 'absolute',
    transform: 'translate(2rem,2rem)',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const VideoScreen = ({ onClose, scanCallback }) => {
  const classes = useStyle();
  const [cameraPermission] = useScanQrcode(scanCallback, onClose);

  useEffect(() => {
    if (cameraPermission === 'fail' || cameraPermission === 'finish') {
      onClose();
    }
  }, [cameraPermission]);

  return (
    <div className={classes.root}>
      <video id="scanQrcodeVideo" className={classes.video} />
      {cameraPermission === 'success' && <CloseIcon id="close" onClick={onClose} className={classes.closeIcon} />}
    </div>
  );
};

const ScanPortal = ({ onClose, scanCallback }) => {
  const bodyDocument = document.getElementsByTagName('body')[0];
  const el = document.createElement('div');

  useEffect(() => {
    bodyDocument.appendChild(el);
    return () => bodyDocument.removeChild(el);
  }, [el, bodyDocument]);

  return createPortal(<VideoScreen onClose={onClose} scanCallback={scanCallback} />, el);
};

export default ScanPortal;
